import { render, staticRenderFns } from "./PerfectJourneyItem.vue?vue&type=template&id=ea33d280&scoped=true&"
import script from "./PerfectJourneyItem.vue?vue&type=script&lang=js&"
export * from "./PerfectJourneyItem.vue?vue&type=script&lang=js&"
import style0 from "./PerfectJourneyItem.vue?vue&type=style&index=0&id=ea33d280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea33d280",
  null
  
)

export default component.exports